<div *ngIf="ownerDetailsForm" class="contact-details row">
  <div class="col-md-12">
    <form class="row" [formGroup]="ownerDetailsForm" autocomplete="off">
      <div class="col-md-12 col-lg-6">
        <div>
          <div formGroupName="owner">
            <h5>Owner Details</h5>
            <hr>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label>First Name</mat-label>
                  <input
                    matInput
                    id="firstName"
                    formControlName="firstName"
                    placeholder="First Name"
                    type="text" trim="blur"
                    required autocomplete="off">
                  <mat-error
                      *ngIf="ownerDetailsForm.get('owner').get('firstName').touched && ownerDetailsForm.get('owner').get('firstName').errors && ownerDetailsForm.get('owner').get('firstName').errors.required"
                      class="error-message"
                      style="color: #ad2c23;">
                    First Name is required.
                  </mat-error>
                  <mat-error
                      *ngIf="ownerDetailsForm.get('owner').get('firstName').touched && ownerDetailsForm.get('owner').get('firstName').errors && ownerDetailsForm.get('owner').get('firstName').errors.maxlength"
                      class="error-message"
                      style="color: #ad2c23;">
                    You have exceeded the maximum number of 100 characters.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label>Last Name</mat-label>
                    <input
                      matInput
                      id="lastName"
                      formControlName="lastName"
                      placeholder="Enter last name"
                      type="text" trim="blur" autocomplete="off"
                      required>
                  <mat-error
                    *ngIf="ownerDetailsForm.get('owner').get('lastName').touched && ownerDetailsForm.get('owner').get('lastName').errors && ownerDetailsForm.get('owner').get('lastName').errors.required"
                    class="error-message"
                    style="color: #ad2c23;">
                    Last Name is required.
                  </mat-error>
                  <mat-error
                      *ngIf="ownerDetailsForm.get('owner').get('lastName').touched && ownerDetailsForm.get('owner').get('lastName').errors && ownerDetailsForm.get('owner').get('lastName').errors.maxlength"
                      class="error-message"
                      style="color: #ad2c23;">
                    You have exceeded the maximum number of 100 characters.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label>Email Address</mat-label>
                  <input
                    matInput
                    id="emailAddress1"
                    name="emailAddress1"
                    formControlName="emailAddress1"
                    placeholder="Enter email address"
                    type="text" trim="blur"
                    required autocomplete="tel">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline" class="no-bottom-pading">
                  <mat-label>Primary Phone Number</mat-label>
                  <input
                    matInput
                    id="telephone1"
                    mask="(000) 000-0000"
                    formControlName="telephone1"
                    placeholder="Primary Phone Number"
                    type="tel"
                    required autocomplete="tel">
                    <mat-error *ngIf="ownerDetailsForm.get('owner').get('telephone1').hasError('required')">
                      Primary Phone Number is required
                    </mat-error>
                    <mat-error *ngIf="ownerDetailsForm.get('owner').get('telephone1').hasError('pattern')">
                      Primary Phone Number is invalid
                    </mat-error>
                  <!-- <mat-error
                    *ngIf="ownerDetailsForm.get('owner').get('telephone1').touched && ownerDetailsForm.get('owner').get('telephone1').errors && ownerDetailsForm.get('owner').get('telephone1').errors.required">
                    Primary Phone is required.
                  </mat-error> -->
                  <!-- <mat-error
                    *ngIf="ownerDetailsForm.get('owner').get('telephone1').touched && ownerDetailsForm.get('owner').get('telephone1').errors && ownerDetailsForm.get('owner').get('telephone1').errors.pattern">
                    Please enter a valid 10-digit phone number.
                  </mat-error> -->
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-checkbox
                  name="telephone1sms"
                  id="telephone1sms"
                  formControlName="telephone1sms">
                  Receive important text alerts to your primary phone number.
                </mat-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline" class="no-bottom-pading">
                  <mat-label>Secondary Phone Number</mat-label>
                  <input
                    matInput
                    id="telephone2"
                    mask="(000) 000-0000"
                    formControlName="telephone2"
                    placeholder="Enter secondary phone number"
                    type="tel" autocomplete="tel">
                    <mat-error *ngIf="ownerDetailsForm.get('owner').get('telephone1').hasError('pattern')">
                      Secondary Phone Number is invalid
                    </mat-error>
                  <!-- <mat-error
                    *ngIf="ownerDetailsForm.get('owner').get('telephone2').touched && ownerDetailsForm.get('owner').get('telephone2').errors">
                    Please use a valid 10-digit phone number.
                  </mat-error> -->
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-checkbox
                  name="telephone2sms"
                  id="telephone2sms"
                  formControlName="telephone2sms">
                  Receive important text alerts to your secondary phone number.
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">
            <mat-checkbox
              [checked]="useForMailing"
              [disabled]="getMailingAddressDisabled() === true"
              (change)="mailingAddressFormChange($event)">
              Use property address as mailing address.
            </mat-checkbox>
          </div>
        </div>
        <div formGroupName="address1">
          <div *ngIf="useForMailing">
            <div><strong>{{ownerDetailsForm.get('address1').get('address1_Line1').value}}</strong></div>
            <div><strong>{{ownerDetailsForm.get('address1').get('address1_Line2').value}}</strong></div>
            <div><strong>{{ownerDetailsForm.get('address1').get('address1_City').value}},
            {{ownerDetailsForm.get('address1').get('address1_StateOrProvince').value}}
            {{ownerDetailsForm.get('address1').get('address1_PostalCode').value}}</strong></div><br />
          </div>
          <div *ngIf="!useForMailing">
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label>Address Line 1</mat-label>
                  <input
                    matInput
                    #address1_Line1
                    ebbGoogleAutocomplete
                    (whenSelected)="openDropdown($event)"
                    (keyup)="onKey($event)"
                    (focus)="onFocus($event)"
                    class="row"
                    name="address1_Line1"
                    formControlName="address1_Line1"
                    id="address1_Line1"
                    placeholder="Enter Address"
                    type="text" trim="blur"
                    autocomplete="off"
                    maxlength="100">
                  <mat-error>
                    Address is required.
                  </mat-error>
                  <mat-hint *ngIf="address1_Line1.value?.length === 100">
                    You have reached the maximum number of 100 characters.
                  </mat-hint>
                  <mat-error
                        *ngIf="ownerDetailsForm.get('address1').get('address1_Line1').errors && ownerDetailsForm.get('address1').get('address1_Line1').errors.validateAddress">
                        Invalid address. Please <a href="/contact" target="_blank">contact us</a>.
                    </mat-error>
                </mat-form-field>
                <div class="pac-wrapper">
                  <div #resultDropDown *ngIf="listResults.length" id="resultDropDown" class="pac-container pac-logo">
                    <div [class.pac-item-selected]="result.selected" class="pac-item" *ngFor="let result of listResults" (click)="getPlaceDetails(result)">
                      <span class="pac-icon pac-icon-marker"></span>
                      <span class="pac-item-query">{{result.text}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label>Address Line 2</mat-label>
                  <input
                    matInput
                    #address1_Line2
                    name="address1_Line2"
                    formControlName="address1_Line2"
                    id="address1_Line2"
                    placeholder="Apt, Ste"
                    type="text" trim="blur"
                    autocomplete="off"
                    maxlength="100">
                  <mat-hint *ngIf="address1_Line2.value.length === 100">
                    You have reached the maximum number of 100 characters.
                  </mat-hint>
                  <mat-error
                        *ngIf="ownerDetailsForm.get('address1').get('address1_Line2').errors && ownerDetailsForm.get('address1').get('address1_Line2').errors.pattern">
                        Invalid address. Please <a href="/contact" target="_blank">contact us</a>.
                    </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label>City</mat-label>
                  <input
                    matInput
                    #address1_City
                    name="address1_City"
                    formControlName="address1_City"
                    id="address1_City"
                    placeholder="Enter City"
                    type="text" trim="blur"
                    autocomplete="off"
                    maxlength="100">
                  <mat-error>
                    City is required.
                  </mat-error>
                  <mat-hint *ngIf="address1_City.value?.length === 100">
                    You have reached the maximum number of 100 characters.
                  </mat-hint>
                  <mat-error
                        *ngIf="ownerDetailsForm.get('address1').get('address1_City').errors && ownerDetailsForm.get('address1').get('address1_City').errors.pattern">
                        Invalid address. Please <a href="/contact" target="_blank">contact us</a>.
                    </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label>State</mat-label>
                  <input
                    matInput
                    #address1_StateOrProvince
                    name="address1_StateOrProvince"
                    formControlName="address1_StateOrProvince"
                    id="address1_StateOrProvince"
                    placeholder="Enter State"
                    autocomplete="off"
                    type="text" trim="blur" maxlength="2">
                    <mat-error>
                      State is required.
                    </mat-error>
                    <mat-error
                        *ngIf="ownerDetailsForm.get('address1').get('address1_StateOrProvince').errors && ownerDetailsForm.get('address1').get('address1_StateOrProvince').errors.pattern">
                        Invalid address. Please <a href="/contact" target="_blank">contact us</a>.
                    </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label>ZIP Code</mat-label>
                  <input
                    class="row"
                    matInput
                    #address1_PostalCode
                    name="address1_PostalCode"
                    formControlName="address1_PostalCode"
                    id="address1_PostalCode"
                    placeholder="Enter ZIP Code"
                    type="text" trim="blur"
                    autocomplete="off"
                    maxLength="10">
                  <mat-error
                    *ngIf="ownerDetailsForm.get('address1').get('address1_PostalCode').errors && ownerDetailsForm.get('address1').get('address1_PostalCode').errors.required"
                    >
                    Zip Code is required.
                  </mat-error>
                  <mat-hint *ngIf="address1_PostalCode.value?.length === 10">
                    You have reached the maximum number of 10 characters.
                  </mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="row" *ngIf="!ownerDetailsForm.get('coowner')">
          <div class="col-md-12">
            <button
              mat-raised-button
              class="add-co-owner"
              type="button"
              (click)="coownerChange(true)">
            {{addcoownerquestion}}
            </button>
            <br />
            <br />
          </div>
        </div>
        <div class="row" *ngIf="ownerDetailsForm.get('coowner')">
          <div class="col-md-12">
            <button
              mat-button color="primary"
              class="remove-co-owner float-right short-button"
              type="button"
              (click)="coownerChange(false)">
                {{removeCoownerLabel}}
            </button>
            <h5>{{detailsCoownerLabel}}</h5>
            <hr>
            <div formGroupName="coowner">
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field appearance="outline">
                    <mat-label>First Name</mat-label>
                    <input
                      matInput
                      type="text" trim="blur"
                      formControlName="coownerFirstName"
                      name="coownerFirstName"
                      id="coownerFirstName"
                      placeholder="Enter first name"
                      autocomplete="off"
                      required>
                    <mat-error
                        *ngIf="ownerDetailsForm.get('coowner').get('coownerFirstName').touched && ownerDetailsForm.get('coowner').get('coownerFirstName').errors && ownerDetailsForm.get('coowner').get('coownerFirstName').errors.required">
                      First Name is required.
                    </mat-error>
                    <mat-error
                        *ngIf="ownerDetailsForm.get('coowner').get('coownerFirstName').touched && ownerDetailsForm.get('coowner').get('coownerFirstName').errors && ownerDetailsForm.get('coowner').get('coownerFirstName').errors.maxlength">
                      You have exceeded the maximum number of 100 characters.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field appearance="outline">
                    <mat-label>Last Name</mat-label>
                    <input
                      matInput
                      type="text" trim="blur"
                      formControlName="coownerLastName"
                      name="coownerLastName"
                      id="coownerLastName"
                      placeholder="Enter last name"
                      autocomplete="off"
                      required>
                    <mat-error
                      *ngIf="ownerDetailsForm.get('coowner').get('coownerLastName').touched && ownerDetailsForm.get('coowner').get('coownerLastName').errors && ownerDetailsForm.get('coowner').get('coownerLastName').errors.required">
                      Last Name is required.
                    </mat-error>
                    <mat-error
                        *ngIf="ownerDetailsForm.get('coowner').get('coownerLastName').touched && ownerDetailsForm.get('coowner').get('coownerLastName').errors && ownerDetailsForm.get('coowner').get('coownerLastName').errors.maxlength">
                      You have exceeded the maximum number of 100 characters.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                      <input
                        matInput
                        type="text" trim="blur"
                        formControlName="coownerEmail"
                        name="coownerEmail"
                        id="coownerEmail"
                        placeholder="Enter email"
                        autocomplete="off">
                      <mat-error
                          *ngIf="ownerDetailsForm.get('coowner').get('coownerEmail').touched && ownerDetailsForm.get('coowner').get('coownerEmail').errors && ownerDetailsForm.get('coowner').get('coownerEmail').errors.pattern">
                        Please enter the a valid email.
                      </mat-error>
                      <mat-error
                          *ngIf="ownerDetailsForm.get('coowner').get('coownerEmail').touched && ownerDetailsForm.get('coowner').get('coownerEmail').errors && ownerDetailsForm.get('coowner').get('coownerEmail').errors.maxlength">
                        You have exceeded the maximum number of 100 characters.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="no-bottom-pading">
                    <mat-label>Primary Phone Number</mat-label>
                    <input
                      matInput
                      type="tel"
                      formControlName="coownerPhone"
                      [textMask]="{mask: phoneMask}"
                      name="coownerPhone"
                      id="coownerPhone"
                      placeholder="Enter primary phone number" autocomplete="off">
                    <mat-error
                      *ngIf="ownerDetailsForm.get('coowner').get('coownerPhone').touched && ownerDetailsForm.get('coowner').get('coownerPhone').errors && ownerDetailsForm.get('coowner').get('coownerPhone').errors.pattern">
                      Please enter a valid 10-digit phone number.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <mat-checkbox
                    formControlName="coownerPhoneSMS"
                    name="coownerPhoneSMS"
                    id="coownerPhoneSMS" autocomplete="off">
                   {{phone1Alert}}
                  </mat-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="no-bottom-pading">
                    <mat-label>Secondary Phone Number</mat-label>
                    <input
                      matInput
                      id="coownerPhoneAlt"
                      formControlName="coownerPhoneAlt"
                      [textMask]="{mask: phoneMask}"
                      placeholder="Enter secondary phone number"
                      type="tel" autocomplete="off">
                    <mat-error
                      *ngIf="ownerDetailsForm.get('coowner').get('coownerPhoneAlt').touched && ownerDetailsForm.get('coowner').get('coownerPhoneAlt').errors && ownerDetailsForm.get('coowner').get('coownerPhoneAlt').errors.pattern">
                      Please enter a valid 10-digit phone number.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <mat-checkbox
                    name="coownerPhoneAltSMS"
                    id="coownerPhoneAltSMS"
                    formControlName="coownerPhoneAltSMS">
                  {{phone2Alert}}
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <button
          mat-button
          matStepperPrevious
          type="button"
          id="go-back-button"
          class="go-back">
          GO BACK
        </button>
        &nbsp;
        <button
          *ngIf="program.typeCodeOptionSet === 'CEA BB'"
          mat-raised-button
          type="button"
          id="section-stepper-ceabb"
          class="next-step float-right" color="primary"
          (click)="openDialog(_userPolicy)"
          [disabled]="!nextStepEnabled(ownerDetailsForm)">
          <div style="display: flex; align-items: center;">
              
            <span>NEXT STEP</span>
            <mat-spinner *ngIf="loading" diameter="20" class="spinner"></mat-spinner>
          </div>          
        </button>
        <button
          *ngIf="program.typeCodeOptionSet !== 'CEA BB'"
          mat-raised-button
          
          type="submit"
          id="section-stepper-not-ceabb"
          class="next-step float-right" color="primary"
          (click)="emitContact(ownerDetailsForm.value)"
          [disabled]="loading || !nextStepEnabled(ownerDetailsForm)">
        <div style="display: flex; align-items: center;">
              
            <span>NEXT STEP</span>
            <mat-spinner *ngIf="loading" diameter="20" class="spinner"></mat-spinner>
          </div>
        </button>
      </div>
    </form>
  </div>
</div>
